
import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MetaService } from '@web/csl-lib-services';


@Component({
  selector: 'app-clinic-site-footer',
  standalone: true,
  imports: [],
  templateUrl: './clinic-site-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './clinic-site-footer.component.css',
})
export class ClinicSiteFooterComponent implements OnInit {
  protected year: number = new Date().getFullYear();
  protected version: string = environment.version;
  protected apiVersion = signal('');
  protected dbVersion = signal('');
  readonly metaService: MetaService;

  constructor() {
    this.metaService = inject(MetaService);
  }

  ngOnInit() {

    this.metaService.getApiVersion().subscribe((apiVersion: string) => {
      this.apiVersion.set(apiVersion);
    });

    this.metaService.getDbVersion().subscribe((dbVersion: string) => {
      this.dbVersion.set(dbVersion);
    });
  }
}

